module.exports = __webpack_public_path__ + "assets/img/69_313_4.373dae0a.jpg";